import { mergeStyles } from "@fluentui/merge-styles";
import { keyframes } from "@fluentui/merge-styles";
import { tokens } from "@fluentui/react-components";
import { FONT_SIZE_SMALL } from "../../config/fontSizes";

const spin = keyframes({
  from: {
    transform: "rotate(0deg)",
  },
  to: {
    transform: "rotate(360deg)",
  },
});

export const refreshActiveIconClasses = mergeStyles({
  color: tokens.colorNeutralForeground2,
  animationName: spin,
  animationDuration: "1000ms",
  animationIterationCount: "infinite",
  animationTimingFunction: "linear",
});

const iconHover = {
  ":hover": {
    color: tokens.colorBrandForeground1,
  },
};

export const refreshIconClasses = mergeStyles({
  color: tokens.colorNeutralForeground2,
  ...iconHover,
});

export const backIconClasses = mergeStyles({
  color: tokens.colorNeutralForeground2,
  ...iconHover,
});

export const followIconClass = mergeStyles({
  fontSize: "20px",
  color: tokens.colorNeutralForeground2,
  ...iconHover,
});

export const toolbarIconClass = mergeStyles({
  color: tokens.colorNeutralForeground2,
  fontSize: "20px",
  ...iconHover,
});

export const wrapperClass = mergeStyles({
  position: "sticky",
  width: "100%",
  background: "#fff",
  top: 0,
  zIndex: 10,
});


export const testBarContentClass = mergeStyles({
  display: "flex",
  alignItems: "center",
  gap: 12,
});

export const notificationMessageBarClass = mergeStyles({
  "& .fui-MessageBarBody": {
    fontSize: FONT_SIZE_SMALL,
  },
});

export const messageBarMarginClass = mergeStyles({
  marginBottom: 8,
  "& .fui-MessageBarBody": {
    fontSize: FONT_SIZE_SMALL,
  },
});

export const toolbarClass = mergeStyles({
  width: "100%",
  overflow: "hidden",
  // Ensure touch targets meet WCAG 2.5.5 (44×44px) on touch devices
  "@media (pointer: coarse)": {
    "& button": {
      minHeight: 44,
      minWidth: 44,
    },
  },
});

export const overflowButtonClass = mergeStyles({
  color: tokens.colorNeutralForeground1,
  marginLeft: "auto",
  flexShrink: 0,
});
